import { Component } from '@angular/core';
import { DialogRef, ModalComponent, CloseGuard } from 'angular2-modal';
import { Modal, BSModalContext } from 'angular2-modal/plugins/bootstrap';
import { AppSettings, enumStatusCodeList } from '../../sharedcomponents/_common/constants/app.constants';
import { AlertService } from '../../sharedcomponents/commonservice/alert.service';
import { Router, NavigationStart } from '@angular/router';
//Services
import { utilityService } from '../../sharedcomponents/commonservice/utility.service';
import { loyaltylogin } from '../../_services/userservice/user.loyaltylogin.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
export class CustomModalContext extends BSModalContext {
  public loyaltyCardModel: any;
}

@Component({
  selector: 'app-loyalty-login-step3',
  templateUrl: './loyalty-login.component-Step3.html',
  styleUrls: ['./loyalty-login.component.css'],
  providers: [AlertService]
})
export class loyaltyOTPverificationComponent implements ModalComponent<CustomModalContext> {
  context: CustomModalContext;
  modelTitle;
  textCaption;
  errorMessage;
  wrongOTP = '';
  model: any = {};
  isRegistration: boolean = false;
  constructor(
    public dialog: DialogRef<CustomModalContext>,
    private router: Router,
    public utilserv: utilityService,
    private loyallog: loyaltylogin,
    private alertService: AlertService,
    public translate: TranslateService
  ) {
    this.context = dialog.context;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.dialog.close();
      }
    });
    if (this.context.loyaltyCardModel.RegistrationCode != undefined) {
      this.isRegistration = true;
    }
    const otpValidationType = dialog.context.loyaltyCardModel.methodName;
    switch (otpValidationType) {
      case 'EMAIL':
        this.modelTitle = 'OTPConfirmPopup_lblDescEmail';
        this.textCaption = 'OTPConfirmPopup_inputOTP';
        this.errorMessage = this.translate.instant('Common_lblEnterEmail');
        break;
      case 'SMS':
        this.modelTitle = 'OTPConfirmPopup_desc';
        this.textCaption = 'OTPConfirmPopup_inputOTP';
        this.errorMessage = this.translate.instant('Common_lblEmptyOTP');
        break;
      case 'LASTORDER':
        this.modelTitle = 'TransConfirmPopup_desc';
        this.textCaption = 'TransConfirmPopup_inputTransId';
        this.errorMessage = this.translate.instant('Common_lblLastTrans');
        break;
    }
    this.modelTitle = this.translate.instant(this.modelTitle);
    this.textCaption = this.translate.instant(this.textCaption);
  }

  verifyLoyaltyCardOTP() {
    this.context.loyaltyCardModel.otpValue = this.model.loyaltyCardOTP;
    sessionStorage.methodName = this.context.loyaltyCardModel.methodName;
    this.utilserv.busy = this.loyallog.loyaltyCardVerification(this.context.loyaltyCardModel).subscribe(data => {
      const resJSON = data;
      if (resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.SUCCESS || resJSON.Envelope.Body.CustomerInfoResponse.StatusCode == enumStatusCodeList.userProfileUpdated) {
        if (this.isRegistration) {
          // this.alertService.openErrorAlert(this.translate.instant('Common_lblInfo'), resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
          this.dialog.close();
          this.router.navigate(['/login']);
          return;
        } else if (this.context.loyaltyCardModel.isLoggedIn) {
          this.dialog.close();
          this.loyallog.setEditUserData(data.Envelope.Body.CustomerInfoResponse);
          this.router.navigate(['/editprofile']);
          return;
        } else {
          this.dialog.close();
          this.loyallog.setEditUserData(data.Envelope.Body.CustomerInfoResponse);
          this.router.navigate(['/register']);
          return;
        }
      } else {
        this.wrongOTP = resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage;
        //  this.alertService.openErrorAlert(this.translate.instant('AddToCartSuccess_title'), resJSON.Envelope.Body.CustomerInfoResponse.StatusMessage);
      }
    });
  }

  //for closing existing dialog Box
  closePopup() {
    this.dialog.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/user/loyalty-login/loyalty-login.component-Step3.ts